import React from "react";
import Modal from "@components/ModalTemplate";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import Button from "@components/Button";
import SectionHeader from "../SectionHeader";
import "./style.scss";

export default NiceModal.create(() => {
  const modal = useModal();

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => {
        modal.hide();
      }}
      onAfterClose={() => modal.remove()}
      innerClass={"partner-available-modal"}
      disableClose={true}
    >
      <>
        <SectionHeader>
          Diesen <strong>Gutschein freischalten</strong>
        </SectionHeader>
        <div className="desktop-wrapper">
          <p className="copy">
            Kaufe jetzt auf{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`${import.meta.env.VITE_DG_URL}`}
            >
              myglo.com
            </a>{" "}
            oder{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`${import.meta.env.VITE_VUSE_URL}`}
            >
              vuse.com
            </a>{" "}
            ein, um diesen Gutschein freizuschalten*.
          </p>
          <p className="desc">
            *Der Gutschein wird innerhalb von 24 Stunden nach Abschluss der
            Transaktion freigeschaltet.
          </p>
        </div>
        <div className="buttons-wrapper">
          <Button
            btnClass="yellow"
            action={() => {
              modal.hide();
            }}
          >
            OK
          </Button>
        </div>
      </>
    </Modal>
  );
});
